import { Trigger } from 'modules/automations/store/models/Trigger'

export function isWeeklyOrMonthlyTrigger(trigger: string) {
  return [Trigger.ContentKinds.weekly, Trigger.ContentKinds.monthly].includes(trigger)
}

export function isWeeklyOrMonthlyOrTrimesterOrYearlyTrigger(trigger: string) {
  return [
    Trigger.ContentKinds.weekly,
    Trigger.ContentKinds.monthly,
    Trigger.ContentKinds.trimester,
    Trigger.ContentKinds.yearly,
  ].includes(trigger)
}
